import { createSlice } from '@reduxjs/toolkit'

export const pipedriveUserSlice = createSlice({
    name: 'pipedriveUsers',
    initialState: {
        users: [],
    },
    reducers: {
        load: (state, action) => {
            state.users = action.payload
        },
    }
})
export default pipedriveUserSlice.reducer

export const { load } = pipedriveUserSlice.actions

export const getAllUsers = (state) => state.pipedriveUsers.users || [];
// export const getbyEmail = (state, id) => state.salesAreas.salesAreas.find(sa => sa.ID === id);
